'use client';
import Link from '@/components/WrappedLink';
import Typography from '../typography/typography.component';
import { useAnalytics } from '@/integrations';
import { useTranslation } from '@/hook';
import styles from './styles.module.scss';

export default function LinkItemClient({
    path,
    label,
}: {
    path: string;
    label: string;
}) {
    const { t } = useTranslation();
    const { trackEvent } = useAnalytics();
    return (
        <Link
            className={styles.navLink}
            href={path}
            onClick={() => {
                trackEvent('Screen: Financing Page', {
                    sourceScreen: 'Header',
                });
            }}
        >
            <Typography variant={'body1Medium'}>{t(label)}</Typography>
        </Link>
    );
}
